<template>
  <div class="home_page">
    <GoodsSearch
      @search="onGoodsSearch"
      ref="goodsSearchRef"
      :tab="'02'"
    ></GoodsSearch>
    <GoodsList
      ref="goodsListRef"
      :goodList="goodList"
      :page="page"
      :total="total"
      @refushDataList="refushDataList"
    ></GoodsList>
    <div class="no_show_message" v-show="!total && !reqLoading">
      <img src="@/assets/img/good/noGood.png" :alt="$t('product.noGoods')" />
      <div>{{ $t("product.noGoods") }}</div>
    </div>
    <div v-loading="reqLoading" v-if="reqLoading">
    </div>
  </div>
</template>
<script>
import GoodsSearch from "./components/goodsSearch.vue";
import GoodsList from "./components/goodListScroll.vue";
export default {
  components: { GoodsSearch, GoodsList },
  data() {
    return {
      reqLoading: false,
      searchParams: {},
      goodList: [],
      page: 1,
      total: 0,
    };
  },
  methods: {
    onGoodsSearch(res) {
      this.searchParams = res;
      this.refushDataList(1);
    },
    // 查询商品列表及数据条数
    refushDataList(page = this.page, reset = true) {
      if (this.reqLoading) {
        return false;
      }
      this.reqLoading = true;
      this.page = page;
      if (page === 1) {
        this.goodList = [];
        this.total = 0;
      }
      this.$http
        .post(`/front/order/lclb/custsp/stockByOrdinaryWebSite`, {
          limit: 20,
          page: page,
          ...this.searchParams,
          // 页签分类(02协议商品；04集团协议商品)"
          tab: "02",
          companyId: this.$store.state.user.defaultCompanyId
        })
        .then(({ data: res }) => {
          this.reqLoading = false;
          if (res.code !== 0) {
            this.goodList = [];
            this.total = 0;
            return false;
          }
          // console.log('refushDataList',res.data.data, this.goodList);
          
          if (reset) {
            this.goodList.push(...(res.data.data || []));
          } else {
            this.goodList = res.data.data || [];
          }
          //  console.log('refushDataList 2',this.goodList);
          this.total = res.data.count;
        })
        .catch(() => {
          this.reqLoading = false;
          this.goodList = [];
          this.total = 0;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.home_page {
  font-family: Alibaba PuHuiTi;
}
</style>
